import React from "react";
import cns from "classnames";
import Typography, { TypographyProps } from "@material-ui/core/Typography";
import { ThemeType } from "@theme";
import { makeStyles } from "@material-ui/core/styles";

type Props = Partial<TypographyProps>;

export function Paragraph(props: Props) {
  const { children, className, ...rest } = props;

  const classes = useStyles({});

  return (
    <Typography component={"p" as any} className={cns(classes.root, className)} {...rest}>
      {children}
    </Typography>
  );
}

const useStyles = makeStyles((theme: ThemeType) => ({
  root: {
    paddingBottom: theme.spacing(),

    "&:last-child": {
      paddingBottom: 0
    }
  }
}));
